module.exports = __webpack_public_path__ + "media/images/sp-hd-sign-in-logo-7044530942727db66b8e2e304bdeb930.png";